import { NAWRIS_URL } from "@/config/app";


export const getOrderLink = code => {
    return NAWRIS_URL + "OrderDetails/" + code;
}